export const GET_BAND_SUCCESS = "GET_BAND_SUCCESS";
